export default __webpack_public_path__ + "static/media/loading-circle.ddfd9ba7.png";